/**
 * Centralized pricing constants for lab-related features
 */

/**
 * Standard clinical fee charged for lab order clinical review
 */
export const STANDARD_CLINICAL_FEE = 30

/**
 * Estimated insurance copay shown when actual insurance price is unavailable
 */
export const ESTIMATED_INSURANCE_COPAY = 30
